<template>
  <div class="experience-wrapper--tab-visa">
    <el-card class="box-card experience-wrapper--section-visa" shadow="never">
      <div slot="header" class="clearfix">
        <el-form
          :model="visa"
          :inline="true"
          label-position="right"
          class="form-countries d--grid"
        >
          <el-form-item :label="$t(`${base}.visa.from`)">
            <LazyLoading
              :key="`visa-from`"
              :loaded="lazy.from"
              @loaded="(e) => (lazy.from = e)"
            >
              <LadCountries
                v-if="lazy.from"
                clearable
                filterable
                :default="country"
                @change="handleUpdateFromCountry"
              />
            </LazyLoading>
          </el-form-item>

          <el-form-item :label="$t(`${base}.visa.to`)">
            <LazyLoading
              :key="`visa-to`"
              :loaded="lazy.to"
              @loaded="(e) => (lazy.to = e)"
            >
              <LadCountries
                v-if="lazy.to"
                clearable
                filterable
                :disabled="true"
                :default="exExperience.country"
                @change="handleUpdateToCountry"
              />
            </LazyLoading>
          </el-form-item>
        </el-form>
      </div>
      <div class="experience-wrapper--section-visa-content">
        <p v-if="visa.from !== undefined && visaInfo">
          <i class="el-icon-info" />
          <span>{{ visaInfo }}</span>
        </p>
        <p v-else>{{ $t(`${base}.visa.default_text`) }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LadTabVisa',
  components: {
    LadCountries: () =>
      import(/* webpackChunkName: "lad-countries" */ '@/components/countries'),
  },
  data() {
    return {
      base: 'experience.faq',
      form: { search: null, categories: [] },
      visaInfo: null,
      visa: { from: null /** desde */, to: undefined /** hasta */ },
      lazy: {
        from: false,
        to: false,
      },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('app', ['country']),
    ...mapState('experience', {
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        country: state.experience.country.alpha_3_code,
      }),
    }),
  },
  watch: {
    'visa.from'(value) {
      this.requiredVisa()
    },
    'visa.to'(value) {
      this.requiredVisa()
    },
  },
  mounted() {
    this.$emit('mounted')

    if (this.exExperience.uuid) {
      this.requiredVisa()
    }
  },
  methods: {
    handleUpdateFromCountry(country) {
      this.visa.from = country
    },
    handleUpdateToCountry(country) {
      this.visa.to = country
    },
    async requiredVisa() {
      if (this.visa.from && this.visa.to) {
        try {
          const url = `/api/country/required-visa/${this.visa.from.alpha_3_code}/${this.visa.to.alpha_3_code}`
          const { visa, status } = await this.$axios.get(url)

          if (status === 'success') {
            this.visaInfo = visa.label
          }
        } catch (error) {}
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--tab-visa {
  .experience-wrapper--section-visa {
    .experience-wrapper--section-visa-content {
      p {
        display: table;

        & > * {
          display: table-cell;
          vertical-align: middle;
        }
      }

      i {
        font-size: 2em;
        padding-right: 10px;
      }
    }
  }

  .form-countries {
    grid-template-columns: 1fr 1fr;
    grid-gap: 25px;

    .el-form-item {
      margin: 0;
    }
    .el-select {
      width: 100%;
    }

    .el-form-item__content {
      display: block;
    }
  }
}
</style>
